import React, { useEffect, useState } from 'react'
import { Typography,makeStyles, Divider, IconButton, Button } from '@material-ui/core'

import psychiatry from '../../../../../assests/images/lookingfor/psychiatry.png'
import therapy from '../../../../../assests/images/lookingfor/therapy.png'

import allergy from '../../../../../assests/images/lookingfor/allergy.png'
import cardiology from '../../../../../assests/images/lookingfor/cardiology.png'
import dermatology from '../../../../../assests/images/lookingfor/dermatology.png'
import endocrinology from '../../../../../assests/images/lookingfor/endocrinology.png'
import gastroenterology from '../../../../../assests/images/lookingfor/gastroenterology.png'
import hepatology from '../../../../../assests/images/lookingfor/hepatology.png'
import infectious from '../../../../../assests/images/lookingfor/infectious.png'
import nephrology from '../../../../../assests/images/lookingfor/nephrology.png'
import neurology from '../../../../../assests/images/lookingfor/neurology.png'
import nutritionalServices from '../../../../../assests/images/lookingfor/nutritionalServices.png'
import orthopedics from '../../../../../assests/images/lookingfor/orthopedics.png'
import otolaryngology from '../../../../../assests/images/lookingfor/otolaryngology.png'
import physicalMedicine from '../../../../../assests/images/lookingfor/physicalMedicine.png'
import physicalTherapy from '../../../../../assests/images/lookingfor/physicalTherapy.png'
import pulmonology from '../../../../../assests/images/lookingfor/pulmonology.png'
import rheumatology from '../../../../../assests/images/lookingfor/Rheumatology.png'
import urology from '../../../../../assests/images/lookingfor/urology.png'

import allergyW from '../../../../../assests/images/lookingfor/allergyW.png'
import cardiologyW from '../../../../../assests/images/lookingfor/cardiologyW.png'
import dermatologyW from '../../../../../assests/images/lookingfor/dermatologyW.png'
import endocrinologyW from '../../../../../assests/images/lookingfor/endrocrinologyW.png'
import gastroenterologyW from '../../../../../assests/images/lookingfor/gastroenterologyW.png'
import hepatologyW from '../../../../../assests/images/lookingfor/hepatologyW.png'
import infectiousW from '../../../../../assests/images/lookingfor/infectiousW.png'
import nephrologyW from '../../../../../assests/images/lookingfor/nephrologyW.png'
import neurologyW from '../../../../../assests/images/lookingfor/neurologyW.png'
import nutritionalServicesW from '../../../../../assests/images/lookingfor/nutritionalServicesW.png'
import orthopedicsW from '../../../../../assests/images/lookingfor/orthopedicsW.png'
import otolaryngologyW from '../../../../../assests/images/lookingfor/otolaryngologyW.png'
import physicalMedicineW from '../../../../../assests/images/lookingfor/physicalMedicineW.png'
import physicalTherapyW from '../../../../../assests/images/lookingfor/physicalTherapyW.png'
import pulmonologyW from '../../../../../assests/images/lookingfor/pulmonologyW.png'
import psychiatryW from '../../../../../assests/images/lookingfor/psychiatryW.png'
import therapyW from '../../../../../assests/images/lookingfor/therapyW.png'
import rheumatologyW from '../../../../../assests/images/lookingfor/RheumatologyW.png'
import urologyW from '../../../../../assests/images/lookingfor/urologyW.png'


import { FilterToUTC, specialityOfPrivider } from '../../../../../containers/AppointmentList/utils'
import { calculateAge, getNextTwoBusinessDays, nameAvatar } from '../../../../utils'
import { LoadingButton } from '@mui/lab'
import moment from 'moment'
import { Dialog } from '@mui/material'
import ProviderDetails from '../SelectAProvider/ProviderDetails'
import { providerListForBook } from '../../../../../services/Appointments/appointments'
import { DemoGraphModal } from '../DemographModal'
import Modal from '@mui/material/Modal';
import ReasonForVisitModal from '../ReasonForVisitModal'
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux'
import { setOfferedDate, setPrimaryProviderDetails } from '../../../../../store/actions/appointments'
import { stateList } from '../../../../../containers/AppointmentBooking/constant'
import { useNotification } from '../../../MaterialUi/Notification';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { InsuranceModal } from '../InsuranceModal'
import { setUpdateInsuranceDetails } from '../../../../../store/actions/patient'
import StateConfirmationModal from '../../StateConfirmationModal'
import ProviderNotCredentialedModal from '../../ProviderNotCredentialedModal'

const useStyles = makeStyles(() => ({
    container: {
        width: '100%',
        marginBottom: '17px',
    },
    lookingForHeading: {
        fontFamily: 'Inter !important',
        fontWeight: '600 !important',
        fontSize: '22px !important',
        color: '#000000 !important',
        marginBottom: '20px !important',
    },
    listContainer: {
        width: '320px !important',
        minHeight: '98px !important',
        border: '1.5px solid #5473C9 !important',
        borderRadius: '6px !important',
        display: 'flex !important',
        alignItems: 'center !important',
        justifyContent: 'center !important',
        // background: '#EFF4FF !important',
        padding: '4px !important',
        cursor: 'pointer',
        ['@media (max-width:768px)']: {
            width: '260px !important',
            minHeight: '70px !important',
            padding: '5px 0px !important',
        },
    },
    iconContainer: {
        width: '100%  !important',
        height: '100%  !important',
        display: 'inherit !important',
        justifyContent: 'center !important',
        alignItems: 'center !important',
        flexDirection: 'column  !important',
        borderRadius: '6px !important',
        ['@media (max-width:768px)']: {
            flexDirection: 'unset !important ',
            gap: '9px !important ',
            justifyContent: 'flex-start !important',
            padding: '5px 10px !important',
        },
    },
    iconMainText: {
        fontFamily: 'Inter !important',
        fontWeight: 500,
        fontStyle: 'Medium !important',
        fontSize: '20px !important',
        textAlign: 'center !important',
    },
    iconSubText: {
        fontFamily: 'Inter !important',
        fontWeight: 500,
        fontStyle: 'Medium !important',
        fontSize: '16px !important',
        marginTop: '4px !important',
        textAlign: 'center !important'
    },
    listOuterContainer: {
        display: 'grid !important',
        gap: '20px !important',
        justifyContent: 'center !important',
        gridTemplateColumns: 'repeat(5, 1fr)',
        ['@media (max-width:768px)']: {
            display: 'flex !important',
            gridTemplateColumns: 'unset !important',
            flexWrap: 'wrap !important',
        },
    },
    textMobileView: {
        display: 'flex !important',
        alignItems: 'center !important',
        flexDirection: 'column !important',
    },
    singleProviderContainer: {
        minHeight: '91px !important',
        border: '1px solid #D0D0D0 !important',
        background: '#FCFCFC !important',
        borderRadius: '5px !important',
        minWidth: '470px !important',
        maxWidth: '470px !important',
        marginBottom: '10px !important',
        padding: '10px !important',
        display:'grid',
        gridTemplateColumns: '1fr 200px !important',
        alignItems: 'center !important',
        ['@media (max-width:768px)']: {
            display: 'flex !important',
            justifyContent: 'space-between !important',
            flexDirection: 'column !important',
            minWidth: '270px !important',
            minHeight: '120px !important',
        },
    },
    singleProviderContainerBlank: {
        minWidth: '492px !important',
        maxWidth: '492px !important',
    },
    specialityContainerBox: {
        border: '1px solid #D0D0D0 !important',
        borderRadius: '6px !important',
        padding: '20px !important',
        marginBottom: '3px !important',
        background: '#FCFCFC !important',
        ['@media (max-width:768px)']: {
            border: 'unset !important',
            borderRadius: 'unset !important',
            padding: 'unset !important',
        },
    },
    recentProviderText: {
        fontFamily: 'Inter !important',
        fontWeight: 600,
        fontSize: '22px !important',
        color: '#000000 !important',
        marginBottom: '12px !important',
        textAlign: 'center !important',
        ['@media (max-width:768px)']: {
            marginTop: '10px !important',
        },
    },
    modalCss: {
        padding: '10px !important',
        position: 'absolute !important',
        top: '50% !important',
        left: '50% !important',
        transform: 'translate(-50%, -50%) !important',
        overflow: 'auto !important',
        background: '#fff !important',
    },
    active: {
        background: '#4C67B2 !important',
    },
    deep: {
        background: '#CDDBFF !important',
    },
    light: {
        background: '#EFF4FF !important',
    },
    whiteColor: {
        color: '#fff !important',
    },
    deepColorText: {
        color: '#1C41A6 !important',
    },
    warningMessage: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding:'0px 20px 25px 20px',
        flexDirection: 'column',
        gap: '10px',
    },
    warningHead1:{
        fontSize: '16px', 
        fontFamily: 'Inter',
        color: '#000000',
        fontWeight: 500
    },
    warningHead2:{
        fontSize: '15px', 
        fontFamily: 'Inter',
        color: '#000000',
        fontWeight: 400
    },
    careTeamContainer:{
        display:'flex',
        alignItems: 'center',
        gap: '10px',
        marginRight: '10px',
        scrollbarWidth: 'thin',
        flexDirection: 'unset',
        ['@media (max-width:768px)']: {
            flexDirection: 'column'
        },
    },
    duplicatePatient:{
        background:'#5571C6', 
        width:"100%", 
        height:"48px",
        display: 'flex',
        alignItems: 'center',
        justifyContent:'space-between'
    },
    duplicatePatientHeaderContent:{
        display: "flex",
        alignItems:'center', 
        alignContent: 'center', 
        justifyContent:"end", 
        // paddingRight:"10px",
        cursor:'pointer',
        padding: '2px 10px 5px 0px',
        
    },
    duplicatePatientHeader1:{
        fontSize: '19px', 
        color: '#000',
        margin: '35px 0px 0px 0px',
        fontWeight: "400",
        fontFamily: 'Inter',
        textAlign: 'center',
        lineHeight: '26px'
    },
    duplicatePatientHeader2:{
        fontSize: '19px', 
        color: '#000',
        // margin: '10px 0px 10px 0px',
        fontWeight: "400",
        fontFamily: 'Inter',
        textAlign: 'center',
        lineHeight: '26px'
    },
    root: {
        '& .MuiDialogContent-root': {
            overflow: 'auto',
        },
        '& .MuiDialog-paperWidthSm': {
            maxWidth: '810px',
        }
    },
    existPatientHeader1:{
        fontSize: '22px', 
        fontFamily: 'Inter',
        color: '#fff',
        padding :"10px",
        fontWeight: "450",
        lineHeight: '26px'
    },
}))

const visitTypeMap = {
    'allergy & immunology': "ALLERGYEST",
    'cardiology': "CARDIOLOGYEST",
    'dermatology': "DERMATOLOGYEST",
    'endocrinology': "ENDOCRINOLOGYEST",
    'gastroenterology': "GASTROEST",
    'hepatology': "HEPATOLOGYEST",
    'infectious disease': "IDEST",
    'nephrology': "NEPHROLOGYEST",
    'neurology': "NEUROLOGYEST",
    'nutrition': "NUTRITIONEST",
    'orthopedics': "ORTHOEST",
    'ent/otolaryngology': "OTOLARYNGOLOGYEST",
    'physical medicine & rehabilitation':"PHYMEDEST",
    'physical therapy': "PHYTHERAPYEST",
    'pulmonology': "PULMONOLOGYEST",
    'rheumatology': "RHEUMEST",
    'therapy' : "THERAPYEST",
    'psychiatryA': "PSYEST",
    'psychiatryC': "PSYVHILDEST",
    'urology': "UROLOGYEST"
  };

const initialVisitTypeMap = {
    'allergy & immunology': "ALLERGYINT",
    'cardiology': "CARDIOLOGYINT",
    'dermatology': "DERMATOLOGYINT",
    'endocrinology': "ENDOCRINOLOGYINT",
    'gastroenterology': "GASTROINT",
    'hepatology': "HEPATOLOGYINT",
    'infectious disease': "IDINT",
    'nephrology': "NEPHROLOGYINT",
    'neurology': "NEUROLOGYINT",
    'nutrition': "NUTRITIONINT",
    'orthopedics': "ORTHOINT",
    'ent/otolaryngology': "OTOLARYNGOLOGYINT",
    'physical medicine & rehabilitation': "PHYMEDINT",
    'physical therapy': "PHYTHERAPYINT",
    'pulmonology': "PULMONOLOGYINT",
    'rheumatology': "RHEUMINT",
    'therapy': "THERAPYINT",
    'psychiatryA': "PSYINT",
    'psychiatryC': "PSYCHILDINT",
    'urology': "UROLOGYINT"
};

const getNormalizedSpecialtyKey = (specialty, patientAge) => {
    const normalizedSpecialty = (specialty || '').toLowerCase().trim();
    if (normalizedSpecialty === 'psychiatry') {
        return patientAge >= 18 ? 'psychiatryA' : 'psychiatryC';
    }
    return normalizedSpecialty;
};

const getDefaultVisitTypeBySpecialty = (specialty, patientAge, isInitialVisit) => {
    const specialtyKey = getNormalizedSpecialtyKey(specialty, patientAge);
    return isInitialVisit ? initialVisitTypeMap[specialtyKey] : visitTypeMap[specialtyKey];
};

const getVisitTypeFromMostRecentAppointment = (specialty, patientAge, mostRecentAppointment) => {
    const backendVisitTypeId = (mostRecentAppointment?.visit_type_id || '').toUpperCase();
    const appointmentStatus = (mostRecentAppointment?.appointment_status || '').toUpperCase();

    if (!backendVisitTypeId) {
        return getDefaultVisitTypeBySpecialty(specialty, patientAge, false);
    }

    if (appointmentStatus === 'MADE') {
        return getDefaultVisitTypeBySpecialty(specialty, patientAge, false);
    }

    if (appointmentStatus !== 'CANCELLED' && appointmentStatus !== 'NO SHOW') {
        return getDefaultVisitTypeBySpecialty(specialty, patientAge, false);
    }

    if (backendVisitTypeId.endsWith('INT')) {
        return getDefaultVisitTypeBySpecialty(specialty, patientAge, true);
    }

    if (backendVisitTypeId.endsWith('EST')) {
        return getDefaultVisitTypeBySpecialty(specialty, patientAge, false);
    }

    return getDefaultVisitTypeBySpecialty(specialty, patientAge, false);
};

const Medical = [
    // { id: allergy, name: "Allergy", needBig: true , idw: allergyW, value: "allergy & immunology" },
    // { id: cardiology, name: "Cardiology", needBig: true, idw: cardiologyW, value: "cardiology" },
    // { id: dermatology, name: "Dermatology",needBig: false, idw: dermatologyW, value: "dermatology" },
    // { id: endocrinology, name: "Endocrinology",needBig: false, idw: endocrinologyW, value: "endocrinology" },
    // { id: gastroenterology, name: "Gastroenterology",needBig: false, idw:gastroenterologyW, value: "gastroenterology" },
    // { id: hepatology, name: "Hepatology",needBig: true , idw: hepatologyW, value: "hepatology"},
    // { id: infectious, name: "Infectious Disease",needBig: false, idw:infectiousW,value: "infectious disease" },
    // { id: nephrology, name: "Nephrology" ,needBig: true, idw:nephrologyW, value: "nephrology" },
    // { id: neurology, name: "Neurology",needBig: true, idw:neurologyW, value: "neurology" },
    // { id: nutritionalServices, name: "Nutritional Services",needBig: false, idw:nutritionalServicesW, value: "nutrition" },
    // { id: orthopedics, name: "Orthopedics",needBig: true, idw:orthopedicsW, value: "orthopedics" },
    // { id: otolaryngology, name: "Otolaryngology",needBig: false, idw:otolaryngologyW, value: "ent/otolaryngology" },
    // { id: physicalMedicine, name: "Physical Medicine & Rehabilitation",needBig: true, idw:physicalMedicineW, value: "physical medicine & rehabilitation"},
    // { id: physicalTherapy, name: "Physical Therapy",needBig: false, idw:physicalTherapyW, value: "physical therapy" },
    // { id: pulmonology, name: "Pulmonology",needBig: false, idw: pulmonologyW, value: "pulmonology"  },
    {
        id: psychiatry,
        name: 'Psychiatry- Adult',
        subName: 'Diagnosis & Treatment',
        needBig: true,
        needPadding: true,
        deepColor: true,
        idw: psychiatryW,
        value: 'psychiatryA',
    },
    {
        id: psychiatry,
        name: 'Psychiatry- Child',
        subName: 'Diagnosis & Treatment',
        needBig: true,
        needPadding: true,
        deepColor: true,
        idw: psychiatryW,
        value: 'psychiatryC',
    },
    {
        id: therapy,
        name: 'Psychotherapy ',
        subName: '(Talk)',
        needBig: true,
        deepColor: true,
        idw: therapyW,
        value: 'therapy ',
    }
    // { id: rheumatology, name: "Rheumatology",needBig: false, idw:rheumatologyW, value: "rheumatology"},
    // { id: urology, name: "Urology",needBig: false , idw:urologyW , value: "urology"},
    
  ]
const LookingFor = ({
    name,
    value,
    setValue,
    firstTime = '',
    isMobileView,
    providerDetailsFromPatient,
    providerDetails,
    handleNextStep,
    patientState = '',
    setProviderVisitType,
    reasonForVisitText,
    setReasonForVisitText,
    selctedProviderDetails,
    selectedTime,
    setSteps,
    patientHaveInsurance,
    currentInsurance,
    carrierList = [],
    setProviderDetailsModalOpen,
    setReasonForVisitModalOpen,
    setDemographicsModalOpen,
    setInsuranceModalOpen,
    setCareTeamFlow,
    setCareTeamSpecialty,
    setCareTeamProviderCount,
    providerIds = [],
    onCareTeamTimeSelected,
    reopenProviderDetails,
    setReopenProviderDetails,
}) => {
    const notification = useNotification()
    const classes = useStyles()
    const dispatch = useDispatch()
    const [filterTime, setFilterTime] = React.useState({
        startTime: null,
        endTime: null,
    })
    const [providerDetailsWithSlot, setProviderDetailsWithSlot] = useState([])
    const [selectedProviderDetails, setSelectedProviderDetails] = useState({})
    const [providerDetailsWithSlotLoading, setProviderDetailsWithSlotLoading] = useState(false)
    const [providerDetailsModal, setProviderDetailsModal] = useState(false)
    const [providerDetailsNotfoundModal, setProviderDetailsNotfoundModal] = useState(false)
    const [openTheDisableSpecialityModal, setOpenTheDisableSpecialityModal] = useState(false)
    const [providerSpecialities, setProviderSpecialities] = useState([])
    const [openReasonForvisit, setOpenReasonForvisit] = useState(false)
    const [openDemoGraphy, setOpenDemoGraphy] = useState(false)
    const [prodiverDetailsNotFoundReason, setproviderDetailsNoteDoundReason] = useState('')
    const [errorIngetAvailable, setErrorInGetAvailable] = useState(false)
    const PatientCreateObject = useSelector((state) => state?.patient?.patientCreateObject)
    const timeZoneOfPatient = useSelector((state) => state?.patient?.patientTimeZone)
    const patientAge = calculateAge(PatientCreateObject?.dob)

    const [visibleItems, setVisibleItems] = useState([])
    const [currentIndex, setCurrentIndex] = useState(0)
    const itemsPerPage = 2
    const [showSpecialties, setShowSpecialties] = useState(false)
    const [openInsuranceModal, setOpenInsuranceModal] = useState(false)
    const updatedInsurance = useSelector((state) => state?.patient?.insuranceDetails)

    const resolveCareTeamVisitType = (providerItem = {}) =>
        getVisitTypeFromMostRecentAppointment(
            providerItem?.profile_specialty || providerItem?.specialities?.[0],
            patientAge,
            providerItem?.mostRecentAppointment
        );

    // State location confirmation modal (care team path)
    const [showStateModal, setShowStateModal] = useState(false)
    const [localConfirmedState, setLocalConfirmedState] = useState(patientState || '')
    const [pendingCareTeamProvider, setPendingCareTeamProvider] = useState(null)

    const handlePrev = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? 0 : prevIndex - itemsPerPage
        );
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex + itemsPerPage < providerDetailsFromPatient.length ? prevIndex + itemsPerPage : prevIndex
        );
    };
   
    const setSelectedTime = () => {
        // const isToday = moment().isSame(moment().tz('US/Pacific'), 'day')
        const nowPatientTimeZone = moment().tz(timeZoneOfPatient || 'US/Pacific');
        const nextBusinessDate = getNextTwoBusinessDays(nowPatientTimeZone, 3);
        setFilterTime({
            startTime: FilterToUTC(nextBusinessDate.format('MM/DD/YYYY'), 8,timeZoneOfPatient),
            endTime: FilterToUTC(nextBusinessDate.format('MM/DD/YYYY'), 18,timeZoneOfPatient),
        });
        // const hour = nowPST.format('HH');
        // const minute = nowPST.format('mm');
        // if(isToday){
        //         if (hour < 8) {
        //             return setFilterTime({
        //                 startTime: FilterToUTC(moment().format('MM/DD/YYYY'), 8),
        //                 endTime: FilterToUTC(moment().format('MM/DD/YYYY'), 18),
        //             });
        //           } else {
        //             return setFilterTime({
        //               startTime: FilterToUTC(moment().format('MM/DD/YYYY'), hour,'', minute),
        //               endTime: FilterToUTC(moment().format('MM/DD/YYYY'), 18),
        //             });
        //           }
        // }
    }
    const getTheProviderDetails = async() => {
        try{ 
            setErrorInGetAvailable(false)
            setProviderDetailsWithSlotLoading(true)
            
            //    const checkState = primaryProviderDetails?.states?.some(item=>item?.state == patientState)
            //    if(!checkState){
            //             setProviderDetailsWithSlotLoading(false),
            //             setproviderDetailsNoteDoundReason('state')
            //             return
            //    }
            //    const checkAge = patientAge < 18 && primaryProviderDetails?.care == 'adult' ? false : true
            //    if(!checkAge){
            //             setProviderDetailsWithSlotLoading(false),
            //             setproviderDetailsNoteDoundReason('dob')
            //             return
            //    }
            
            setproviderDetailsNoteDoundReason('')
            const providerDetailsPayload = providerDetailsFromPatient.length > 0 ? 
                providerDetailsFromPatient.map((item)=>({
                    prof_id: item?.profileId,
                    specialty: item?.profile_specialty,
                    title: item?.profileTitle,
                    visit_type: resolveCareTeamVisitType(item)
                }))
            :[] 
        
            const payload = {
                start_date: filterTime?.startTime.format('YYYY-MM-DDTHH:mm:ss[Z]'),
                end_date: filterTime?.endTime.format('YYYY-MM-DDTHH:mm:ss[Z]'),
                is_morning: true,
                is_afternoon: true,
                is_evening: true,
                timezone: timeZoneOfPatient || 'US/Pacific',
                state: localConfirmedState || patientState,
                age: patientAge,
                provider_details: providerDetailsPayload,
                provider_ids: providerIds
            }
            const res = await providerListForBook(payload)
            const data = providerDetailsFromPatient.length && providerDetailsFromPatient.map((item)=>{
                const itemFind = res?.data?.data?.find((value)=> value.id == item?.profileId)
                if(itemFind){
                    return {
                        ...itemFind,
                        mostRecentAppointment: item?.mostRecentAppointment || null,
                        careTeamVisitType: resolveCareTeamVisitType(item)
                    }
                }else{
                    return{
                        "id": item?.profileId,
                        "title": item?.profileTitle,
                        "description": item?.profileDescription,
                        "first_name": item?.profile_firstName,
                        "last_name": item?.profile_lastName,
                        "avatar": item?.prfileImage,
                        "specialities": [item?.profile_specialty],
                        "states": item?.profileStates,
                        "dates": [],
                        "mostRecentAppointment": item?.mostRecentAppointment || null,
                        "careTeamVisitType": resolveCareTeamVisitType(item)
                    }
                }
            })
            setProviderDetailsWithSlot((data.length > 0 ? data : []))
            setProviderDetailsWithSlotLoading(false)
            setErrorInGetAvailable(false)
        }catch(err){
            console.log('err', err)
            notification(err?.data?.message || 'Something went wrong!', 'error')
            setProviderDetailsWithSlotLoading(false)
            setErrorInGetAvailable(true)
        }
    }
    const getState = (value) =>{
        const state = stateList?.find((item) => item?.state == value)
        return state?.stateLabel
    }
    useEffect(()=>{
        setSelectedTime()
        if(firstTime != 'yes'){
            const speciality = []
            for (let i = 0; providerDetailsFromPatient.length > i; i++) {
                const value = providerDetailsFromPatient[i]
                if(!speciality.includes(value?.profile_specialty)){
                    speciality.push(value?.profile_specialty.toLowerCase())
                }
            }
            setProviderSpecialities(speciality)
        }else{
            setProviderSpecialities([])
        }
    },[])

    useEffect(()=>{
        if(filterTime?.startTime && firstTime != 'yes'){
            getTheProviderDetails()
        }
    }, [filterTime, patientState])

    useEffect(()=>{
        const visibleItems = providerDetailsFromPatient.slice(currentIndex, currentIndex + itemsPerPage);
        setVisibleItems(visibleItems)
    },[currentIndex])

     // Reopen care team provider details when navigating back from AppointmentPostBookingModal
    useEffect(() => {
        if (reopenProviderDetails) {
            setProviderDetailsModal(true)
            setReopenProviderDetails?.(false)
        }
    }, [reopenProviderDetails])

    return (
        <>
            <div className="booking_boxes looking-for-container">
                {firstTime != 'yes' && (
                    <>
                        <div style={{ alignSelf: 'center' }}>
                            <Typography className={classes?.recentProviderText}>
                                Your Care Team
                            </Typography>
                            <div className={classes?.careTeamContainer}>
                                {/* {providerDetailsFromPatient.length > 2 && (
                                    <div
                                        style={{
                                            width: !isMobileView && '20px',
                                            height: isMobileView && '40px',
                                        }}>
                                        {currentIndex != 0 && (
                                            <IconButton
                                                onClick={handlePrev}
                                                disabled={currentIndex === 0}>
                                                {isMobileView ? (
                                                    <KeyboardArrowUpIcon
                                                        sx={{ color: '#575757', fontSize: '45px' }}
                                                    />
                                                ) : (
                                                    <ArrowBackIos sx={{ color: '#575757' }} />
                                                )}
                                            </IconButton>
                                        )}
                                    </div>
                                )} */}
                                {currentIndex != 0 && (
                                    <IconButton onClick={handlePrev} disabled={currentIndex === 0}>
                                        {isMobileView ? (
                                            <KeyboardArrowUpIcon
                                                sx={{ color: '#575757', fontSize: '45px' }}
                                            />
                                        ) : (
                                            <ArrowBackIos sx={{ color: '#575757' }} />
                                        )}
                                    </IconButton>
                                )}
                                {visibleItems.length &&
                                    visibleItems.map((item) => {
                                        const fetchedData = providerDetailsWithSlot?.find(
                                            (value) => value?.id == item?.profileId,
                                        )
                                        const displayTitle = fetchedData?.title || item?.profileTitle
                                        const displayFirstName = fetchedData?.first_name || item?.profile_firstName
                                        const displayLastName = fetchedData?.last_name || item?.profile_lastName
                                        const displayAvatar = fetchedData?.avatar || item?.profileImage

                                        return (
                                        <div className={classes.singleProviderContainer}>
                                            <div className="provider_card_content">
                                                <div className={`left_section`}>
                                                    <div>
                                                        {displayAvatar ? (
                                                            <img
                                                                style={{
                                                                    borderRadius: '80px',
                                                                    border: '2px solid #D8D8D8',
                                                                }}
                                                                alt="avatar"
                                                                src={`data:image/jpeg;base64,${displayAvatar}`} //we get the base64 image from advanceMd
                                                                height={63}
                                                                width={60}
                                                            />
                                                        ) : (
                                                            nameAvatar(
                                                                `${displayFirstName} ${displayLastName} `,
                                                            )
                                                        )}
                                                    </div>
                                                    <div className="about_doctor">
                                                        <Typography
                                                            className="name"
                                                            style={{
                                                                color: '#000000',
                                                                whiteSpace: 'normal',
                                                                wordBreak: 'break-word',
                                                            }}>
                                                            {`${displayFirstName} ${displayLastName}${displayTitle ? `, ${displayTitle}` : ''}`}
                                                        </Typography>
                                                        <Typography
                                                            className="practice"
                                                            style={{
                                                                color: '#000000',
                                                                whiteSpace: 'normal',
                                                                wordBreak: 'break-word',
                                                            }}>
                                                            {specialityOfPrivider(
                                                                item?.profile_specialty,
                                                            )}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </div>
                                            {providerDetailsWithSlotLoading && (
                                                <LoadingButton
                                                    loading={providerDetailsWithSlotLoading}
                                                    variant="contained"
                                                    color="success"
                                                    sx={{
                                                        '& .MuiCircularProgress-root': {
                                                            color: '#fff',
                                                        },
                                                        height: '26px',
                                                        fontFamily: 'Inter',
                                                        minWidth: '180px',
                                                        marginBottom: isMobileView && '2px',
                                                    }}
                                                    className="book_buttonNew"
                                                    onClick={() => {}}></LoadingButton>
                                            )}
                                            {!providerDetailsWithSlotLoading && (
                                                <LoadingButton
                                                    loading={providerDetailsWithSlotLoading}
                                                    variant="contained"
                                                    color="success"
                                                    sx={{
                                                        '& .MuiCircularProgress-root': {
                                                            color: '#fff',
                                                        },
                                                        height: '26px',
                                                        fontFamily: 'Inter',
                                                        marginBottom: isMobileView && '2px',
                                                    }}
                                                    className="book_buttonNew"
                                                    disabled={errorIngetAvailable}
                                                    onClick={() => {
                                                        const data = providerDetailsWithSlot?.find(
                                                            (value) => value?.id == item?.profileId,
                                                        )
                                                        setPendingCareTeamProvider({ data, item })
                                                        setShowStateModal(true)
                                                    }}>
                                                    See Appointment Times
                                                </LoadingButton>
                                            )}
                                        </div>
                                        )
                                    })}
                                {visibleItems.length == 1 && !isMobileView && (
                                    <>
                                        <div className={classes.singleProviderContainerBlank}></div>
                                    </>
                                )}
                                {currentIndex + itemsPerPage <
                                    providerDetailsFromPatient.length && (
                                    <IconButton onClick={handleNext}>
                                        {isMobileView ? (
                                            <KeyboardArrowDownIcon
                                                sx={{ color: '#575757', fontSize: '45px' }}
                                            />
                                        ) : (
                                            <ArrowForwardIos sx={{ color: '#575757' }} />
                                        )}
                                    </IconButton>
                                )}
                            </div>
                        </div>
                    </>
                )}
                {firstTime != 'yes' && (
                    <Divider
                        style={{
                            backgroundColor: '#D6D6D6',
                            width: '100%',
                            height: '1px',
                            marginTop: '-10px',
                        }}
                    />
                )}
                {firstTime != 'yes' && !showSpecialties && (
                    <div style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px' }}>
                        <Typography
                            style={{
                                fontFamily: 'Inter',
                                fontWeight: 600,
                                fontSize: '22px',
                                color: '#000000',
                                marginBottom: '10px'
                            }}>
                            Looking for additional care?
                        </Typography>
                        <Typography
                            style={{
                                fontFamily: 'Inter',
                                fontWeight: 400,
                                fontSize: '16px',
                                color: '#000000',
                                marginBottom: '20px'
                            }}>
                            You can continue with your care team or explore other specialties.
                        </Typography>
                        <Button
                            variant="contained"
                            onClick={() => setShowSpecialties(true)}
                            style={{
                                background: '#5473C9',
                                textTransform: 'none',
                                fontSize: '16px',
                                fontWeight: 500,
                                fontFamily: 'Inter',
                                padding: '10px 30px',
                                borderRadius: '6px'
                            }}>
                            Explore other specialties
                        </Button>
                    </div>
                )}
                {firstTime == 'yes' && (
                    <div>
                        <Typography className="step-headers">
                            What kind of care are you looking for?
                        </Typography>
                    </div>
                )}
                {firstTime != 'yes' && showSpecialties && (
                    <div>
                        <Typography className="step-headers">
                            Explore other specialties
                        </Typography>
                    </div>
                )}
                {(firstTime == 'yes' || (firstTime != 'yes' && showSpecialties)) && (
                    <div>
                        <div className={classes.specialityContainerBox}>
                            <div className={classes.listOuterContainer}>
                                {Medical.map((item, index) => (
                                    <div
                                        className={`${classes.listContainer} ${
                                            item?.value === value
                                                ? classes.active
                                                : item?.deepColor
                                                ? classes.deep
                                                : classes.light
                                        }`}
                                        key={index}
                                        onClick={() => {
                                            const specialist =
                                                item?.value == 'psychiatryA' ||
                                                item?.value == 'psychiatryC'
                                                    ? 'psychiatry'
                                                    : item?.value.toLowerCase().trim()
                                            if (firstTime != 'yes') {
                                                if (providerSpecialities.includes(specialist)) {
                                                    setValue('', name)
                                                    setOpenTheDisableSpecialityModal(true)
                                                } else {
                                                    setValue(item?.value, name)
                                                }
                                            } else {
                                                setValue(item?.value, name)
                                            }
                                        }}>
                                        <div
                                            className={classes.iconContainer}
                                            // style={{
                                            //     background:
                                            //       item?.value === value
                                            //         ? '#4C67B2'
                                            //         : item?.deepColor
                                            //         ? '#CDDBFF'
                                            //         : '#EFF4FF',
                                            //     borderRadius: item?.value === value ? '2px' : '0px',
                                            //   }}
                                        >
                                            <div>
                                                <img
                                                    src={item?.value === value ? item?.idw : item?.id}
                                                    alt=""
                                                    style={{
                                                        width: '40px',
                                                        height: '40px',
                                                        objectFit: 'contain',
                                                        paddingTop: item?.needPadding && '1px',
                                                    }}
                                                />
                                            </div>
                                            {isMobileView ? (
                                                <div className={classes.textMobileView}>
                                                    <Typography
                                                        className={`${classes.iconMainText} ${
                                                            item?.value === value
                                                                ? classes?.whiteColor
                                                                : classes?.deepColorText
                                                        } `}
                                                        style={{
                                                            marginTop: '5px',
                                                        }}>
                                                        {item?.name}
                                                    </Typography>
                                                    <Typography
                                                        className={`${classes.iconSubText} ${
                                                            item?.value === value
                                                                ? classes?.whiteColor
                                                                : classes?.deepColorText
                                                        } `}>
                                                        {item?.subName}
                                                    </Typography>
                                                </div>
                                            ) : (
                                                <>
                                                    <Typography
                                                        className={`${classes.iconMainText} ${
                                                            item?.value === value
                                                                ? classes?.whiteColor
                                                                : classes?.deepColorText
                                                        } `}>
                                                        {item?.name}
                                                    </Typography>
                                                    <Typography
                                                        className={`${classes.iconSubText} ${
                                                            item?.value === value
                                                                ? classes?.whiteColor
                                                                : classes?.deepColorText
                                                        } `}
                                                        style={{
                                                            marginBottom: '2px',
                                                        }}>
                                                        {item?.subName}
                                                    </Typography>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
                <Modal
                    open={providerDetailsModal}
                    onClose={() => {
                        providerDetails({}, {}),
                            setProviderDetailsModal(false),
                            setProviderDetailsModalOpen?.(false),
                            setSelectedProviderDetails({})
                            setCareTeamFlow?.(false)
                    }}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description">
                    <div
                        className={classes?.modalCss}
                        style={{
                            height: isMobileView ? 'calc(100% - 100px)' : 'unset',
                            width: isMobileView ? '96%' : 'unset',
                        }}>
                        <div style={{ display: 'flex', justifyContent: 'end' }}>
                            <IconButton
                                onClick={() => {
                                    dispatch(setOfferedDate(null))
                                    providerDetails({}, {}),
                                        setProviderDetailsModal(false),
                                        setProviderDetailsModalOpen?.(false),
                                        setSelectedProviderDetails({})
                                        setCareTeamFlow?.(false)
                                }}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                        <div>
                            <ProviderDetails
                                providerDetailsForModal={selectedProviderDetails}
                                isMobileView={isMobileView}
                                providerDetails={providerDetails}
                                setProviderVisitType={setProviderVisitType}
                                closeModal={() => {
                                    providerDetails({}, {})
                                    setProviderDetailsModal(false)
                                    setProviderDetailsModalOpen?.(false)
                                    setCareTeamFlow?.(false)
                                }}
                                showDemoGraphy={() => {
                                    setProviderDetailsModal(false)
                                    setProviderDetailsModalOpen?.(false)
                                    const vtId =
                                        selectedProviderDetails?.careTeamVisitType ||
                                        resolveCareTeamVisitType(selectedProviderDetails)
                                    onCareTeamTimeSelected?.(vtId)
                                }}
                                specialty={selectedProviderDetails?.specialities?.[0]}
                                visit_type={
                                    selectedProviderDetails?.careTeamVisitType ||
                                    resolveCareTeamVisitType(selectedProviderDetails)
                                }
                                patientState={localConfirmedState || patientState}
                                selctedValue={selectedTime}
                            />
                        </div>
                    </div>
                </Modal>
                <Dialog
                    open={openReasonForvisit}
                    onClose={() => {
                        setReasonForVisitText('')
                        setOpenReasonForvisit(false)
                        setReasonForVisitModalOpen?.(false)
                        setCareTeamFlow?.(false)
                    }}
                    PaperProps={{
                        style: {
                            width: isMobileView ? 'unset' : '1055px',
                            maxWidth: isMobileView ? 'unset' : '1055px',
                            height: 'unset',
                        },
                    }}>
                    <ReasonForVisitModal
                        reasonForVisitText={reasonForVisitText}
                        setReasonForVisitText={setReasonForVisitText}
                        onClose={() => {
                            setReasonForVisitText('')
                            setOpenReasonForvisit(false)
                            setReasonForVisitModalOpen?.(false)
                            setCareTeamFlow?.(false)
                        }}
                    />
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'end',
                            padding: '0px 23px 23px 23px',
                        }}>
                        <Button
                            className="providerDetailsButton"
                            disabled={reasonForVisitText.trim() == ''}
                            onClick={() => {
                                setOpenReasonForvisit(false)
                                setReasonForVisitModalOpen?.(false)
                                setOpenDemoGraphy(true)
                                setDemographicsModalOpen?.(true)
                            }}>
                            Continue
                        </Button>
                    </div>
                </Dialog>
                {/* State location confirmation modal (care team path) */}
                <StateConfirmationModal
                    open={showStateModal}
                    onClose={() => { setShowStateModal(false); setPendingCareTeamProvider(null) }}
                    patientState={localConfirmedState || patientState || ''}
                    onConfirm={(selectedState) => {
                        setShowStateModal(false)
                        if (!pendingCareTeamProvider) return
                        const { data, item } = pendingCareTeamProvider
                        const providerStates = data?.states || item?.profileStates || []
                        const isCredentialed = providerStates.some(
                            (s) => s.state === selectedState || s === selectedState
                        )
                        if (!isCredentialed) {
                            setproviderDetailsNoteDoundReason('state')
                            setProviderDetailsNotfoundModal(true)
                        } else {
                            setLocalConfirmedState(selectedState)
                            setSelectedProviderDetails(data)
                            setProviderDetailsModal(true)
                            setProviderDetailsModalOpen?.(true)
                            setCareTeamFlow?.(true)
                            setCareTeamSpecialty?.(item?.profile_specialty || data?.specialities?.[0] || '')
                            setCareTeamProviderCount?.(providerDetailsFromPatient?.length || 0)
                        }
                        setPendingCareTeamProvider(null)
                    }}
                />

                <ProviderNotCredentialedModal
                    open={providerDetailsNotfoundModal}
                    onClose={() => setProviderDetailsNotfoundModal(false)}
                />
                {openDemoGraphy && (
                    <DemoGraphModal
                        isOpenModal={openDemoGraphy}
                        setSteps={() => {
                            setOpenDemoGraphy(false)
                            setDemographicsModalOpen?.(false)
                            setCareTeamFlow?.(false)
                        }}
                        handleNextStep={() => {
                            setOpenDemoGraphy(false)
                            setDemographicsModalOpen?.(false)
                            // Only open insurance modal if patient has insurance
                            if (patientHaveInsurance) {
                                setOpenInsuranceModal(true)
                                setInsuranceModalOpen?.(true)
                            } else {
                                // Skip insurance modal and proceed to next step
                                handleNextStep()
                            }
                        }}
                        selctedProviderDetails={selctedProviderDetails}
                        fromPrimary={true}
                        backToProvider={(value) => {
                            setOpenDemoGraphy(false)
                            setDemographicsModalOpen?.(false)
                            setCareTeamFlow?.(false)
                            setSteps(2)
                            // value.toLowerCase() == 'psychiatry'
                            //     ? patientAge >= 18
                            //         ? setValue('psychiatryA', 'lookingFor')
                            //         : setValue('psychiatryC', 'lookingFor')
                            //     : setValue(value, 'lookingFor')
                        }}
                    />
                )}
                {openInsuranceModal && (
                    <InsuranceModal
                        isOpenModal={openInsuranceModal}
                        setSteps={() => {
                            setOpenInsuranceModal(false)
                            setInsuranceModalOpen?.(false)
                            setOpenDemoGraphy(true)
                            setDemographicsModalOpen?.(true)
                        }}
                        handleNextStep={() => {
                            setOpenInsuranceModal(false)
                            setInsuranceModalOpen?.(false)
                            handleNextStep()
                        }}
                       insuranceData={{
                            carrier: updatedInsurance?.carrier || currentInsurance?.carrier || null,
                            subscriber_id:
                                updatedInsurance?.subscriber_id ||
                                currentInsurance?.subscriber_id ||
                                PatientCreateObject?.subscriber_id ||
                                '',
                            insurance_name:
                                updatedInsurance?.insurance_name ||
                                currentInsurance?.insurance_name ||
                                '',
                            insurance_Id:
                                updatedInsurance?.insurance_Id ||
                                currentInsurance?.insurance_Id ||
                                '',
                            relationship:
                                updatedInsurance?.relationship ||
                                currentInsurance?.relationship ||
                                null,
                            group_name:
                                updatedInsurance?.group_name ||
                                currentInsurance?.group_name ||
                                '',
                            group_number:
                                updatedInsurance?.group_number ||
                                currentInsurance?.group_number ||
                                '',
                            member_name:
                                updatedInsurance?.member_name ||
                                currentInsurance?.member_name ||
                                '',
                            member_dob:
                                updatedInsurance?.member_dob ||
                                currentInsurance?.member_dob ||
                                '',
                            patientInsuranceFront:
                                updatedInsurance?.patientInsuranceFront ||
                                currentInsurance?.patientInsuranceFront ||
                                '',
                            patientInsuranceBack:
                                updatedInsurance?.patientInsuranceBack ||
                                currentInsurance?.patientInsuranceBack ||
                                '',
                            }}

                        carrierList={carrierList || []}
                        
                    />
                )}
                <Dialog
                    className={classes?.root}
                    open={openTheDisableSpecialityModal}
                    onClose={() => setOpenTheDisableSpecialityModal(false)}
                    PaperProps={{
                        style: {
                            width: isMobileView ? 'unset' : '772px',
                            height: isMobileView ? 'unset' : '332px',
                        },
                    }}>
                    <div
                        className={classes.duplicatePatient}
                        style={{ height: isMobileView && '60px' }}>
                        <Typography className={classes.existPatientHeader1}>
                            You Already Have a Provider!
                        </Typography>
                        <div
                            className={classes.duplicatePatientHeaderContent}
                            onClick={() => {
                                setOpenTheDisableSpecialityModal(false)
                            }}>
                            <CloseIcon style={{ color: 'white' }} />
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            padding: '0px 35px 0px 35px',
                            gap: '35px',
                        }}>
                        <Typography className={classes.duplicatePatientHeader1}>
                            You already have a provider for this specialty on your care team. <br />
                            Please choose an available appointment time with your current provider.
                        </Typography>
                        <Typography className={classes.duplicatePatientHeader2}>
                            If you’d prefer to switch to a different provider for this specialty,
                            feel free to call us at (562) 268-0955.
                        </Typography>
                        <Button
                            variant="contained"
                            onClick={() => {
                                setOpenTheDisableSpecialityModal(false)
                            }}
                            style={{
                                background: '#5473C9',
                                textTransform: 'none',
                                fontSize: '18px',
                                fontWeight: 550,
                                fontFamily: 'Inter',
                                marginBottom: '37px',
                            }}>
                            <span> Continue</span>
                        </Button>
                    </div>
                </Dialog>
            </div>
        </>
    )
}
export default LookingFor
